'use client'
import { useRef, useCallback, useEffect } from 'react'

type OnClickOutsideType = () => void

export default function useOutsideClick(onClickOutside: OnClickOutsideType) {
  const ref = useRef<HTMLDivElement | null>(null)
  const handleClick = useCallback(
    (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        onClickOutside()
      }
    },
    [onClickOutside]
  )
  useEffect(() => {
    document.addEventListener('mousedown', handleClick)
    return () => {
      document.removeEventListener('mousedown', handleClick)
    }
  }, [handleClick])

  return ref
}
